"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_scss_1 = __importDefault(require("./styles.scss"));
var ModalHeader = function () {
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: styles_scss_1["default"].modalHeader }, { children: [(0, jsx_runtime_1.jsx)("svg", __assign({ preserveAspectRatio: "none", className: styles_scss_1["default"].modalHeaderMask, viewBox: "0 0 580 112", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M122.767 112L0 73.4071V0H580V54.069L122.767 112Z", fill: "#2b59db" }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: styles_scss_1["default"].modalHeaderLogo }, { children: (0, jsx_runtime_1.jsx)("img", { src: require("../../assets/images/logo.svg"), alt: "ahoj logo" }) }))] })));
};
exports["default"] = ModalHeader;
